export const COST_CATEGORIES = [
  { value: "labor",          get label() { return I18n.t("quotes.new.cost_category.labor") },          color: "blue"    },
  { value: "equipment",      get label() { return I18n.t("quotes.new.cost_category.equipment") },      color: "violet"  },
  { value: "materials",      get label() { return I18n.t("quotes.new.cost_category.materials") },      color: "emerald" },
  { value: "subcontracting", get label() { return I18n.t("quotes.new.cost_category.subcontracting") }, color: "amber"   },
  { value: "other",          get label() { return I18n.t("quotes.new.cost_category.other") },          color: "neutral" },
]

const categoryMap = COST_CATEGORIES.reduce((memo, category) => {
  memo[category.value] = category
  return memo
}, {})

export const findCostCategory = value => categoryMap[value] || null

const VISUALS = {
  labor:          { icon: "wrench",      tone: "blue"    },
  equipment:      { icon: "screwdriver-wrench", tone: "violet"  },
  materials:      { icon: "cube",        tone: "emerald" },
  subcontracting: { icon: "handshake",   tone: "amber"   },
  other:          { icon: "ellipsis",    tone: "neutral" },
}

const FALLBACK = { icon: "cube", tone: "neutral" }

export const costCategoryVisual = value => VISUALS[value] || FALLBACK

export const OUVRAGE_VISUAL = { icon: "cubes", tone: "group" }
